import React, { useState, useEffect } from "react";
import HeaderAdmin from "../Components/HeaderAdmin/Header.jsx";
import { Tab, Nav, Form } from "react-bootstrap";
import { FaCalendarAlt } from "react-icons/fa";
import { Link } from "react-router-dom";
import { getreferralbyid } from "../Api/staff.js";
import { Spinner } from "react-bootstrap";
import { updaterefferal } from "../Api/staff.js";
import { getallprojectbyfitter, getcountriesforfitter, getstates, getcities, updatepartykit, getassignunPartys, getprojectbyreferral } from '../Api/iron.js'
import { IoCloseSharp } from "react-icons/io5";
import Loader2 from "../DashboardPages/DashboardComponents/Loader/Loader2.jsx";
import Tabs from 'react-bootstrap/Tabs';
import { useParams } from 'react-router-dom';
import { IoMdEye } from "react-icons/io";
import { useHistory } from 'react-router-dom';
import Modal from 'react-bootstrap/Modal';
import Button from 'react-bootstrap/Button';
import { removefitter } from "../Api/contact.js";
import { activereferral, updatelocation } from "../Api/staff.js";
import { updatestaffrole, staffassignkit } from '../Api/iron.js'

function ViewReferral() {

    const [isLoading, setIsLoading] = useState(false);
    const [errors, setErrors] = useState([]);
    const [apicall, setApicall] = useState(false);
    const [user_id, setUser_id] = useState(0);
    const [validated, setValidated] = useState(false);
    const [filteredData, setFilteredData] = useState([]);
    const [dataNull, setDataNull] = useState(null);
    const [scrolled, setScrolled] = useState(false);

    const [isOpen2, setIsOpen2] = useState(false);
    const [isOpen3, setIsOpen3] = useState(false);
    const [selectedOption2, setSelectedOption2] = useState('Active');
    const [selectedOption3, setSelectedOption3] = useState('International');
    const [selectedOptionid3, setSelectedOptionid3] = useState(0);

    const [dbselectedOption2, setDbSelectedOption2] = useState('Active');
    const [dbselectedOption3, setDbSelectedOption3] = useState('International');
    const [apicallupate, setApicallupdate] = useState(false);

    const [isOpen4, setIsOpen4] = useState(false);
    const [isOpen5, setIsOpen5] = useState(false);

    const [isOpen6, setIsOpen6] = useState(false);

    const [selectkitid, setSelectKitId] = useState(0);
    const [dbselectkitid, setdbselectkitid] = useState(0);
    const [selectroleid, setSelectRoleId] = useState(0);
    const [dbselectroleid, setdbselectroleid] = useState(0);


    const [selectedOption4, setSelectedOption4] = useState('Assign Role');
    const [selectedOption5, setSelectedOption5] = useState('Assign Kit');

    const [selectedOption6, setSelectedOption6] = useState('Assign Party');
    const [selectedOptionid6, setSelectedOptionid6] = useState(0);
    const [selectedOptionDb6, setSelectedOptionDb6] = useState(0);

    const [role, setRole] = useState(1);

    const options4 = [
        { text: 'Fitter / Builder', color: 'orange', id: 8 },
        { text: 'Fitter / Coach', color: 'yellow', id: 1 },
        { text: 'Fitter / Party', color: 'blue', id: 10 },
    ];

    const options5 = [
        { text: 'Righty', id: 0 },
        { text: 'Lefty', id: 1 },
        { text: 'TPT', id: 3 },
        { text: 'Tall', id: 4 },
        { text: 'Junior', id: 5 },
        { text: 'Biz Dev', id: 6 },
    ];


    const [options6, setOption6] = useState([]);

    const getassignkitfunc = () => {
        getassignunPartys().then((response) => {
            if (!response.data.status) {
                console.log(response.data.message);
            } else {
                const data = response.data.data;
                setOption6(data);
            }
        }).catch((err) => {
            console.log(err);
        });
    }

    const toggleDropdown2 = () => {
        setIsOpen2(!isOpen2);
    };

    const toggleDropdown3 = () => {
        setIsOpen3(!isOpen3);
    };


    const options2 = [
        { text: 'Active', color: 'green' },
        { text: 'Deactivate', color: 'red' },
    ];

    const options3 = [
        { id: 0, text: 'Domestic', color: 'purple' },
        { id: 1, text: 'International', color: 'blue' },
    ];

    const selectOption4 = (option) => {
        setSelectedOption4(option.text);
        setSelectRoleId(option.id);
    };

    const selectOption5 = (option) => {
        setSelectedOption5(option.text);
        setSelectKitId(option.id);
    };

    const selectedOptionNew6 = (option) => {
        setSelectedOption6(option.text);
        setSelectedOptionid6(option.party_id);
    };

    const toggleDropdown4 = () => {
        setIsOpen4(!isOpen4);
    };

    const toggleDropdown5 = () => {
        setIsOpen5(!isOpen5);
    };

    const toggleDropdown6 = () => {
        setIsOpen6(!isOpen6);
    };

    const params = useParams();

    const history = useHistory();
    const goBack = () => {
        history.goBack();
    };

    const [userdata, setUserdata] = React.useState({
        fullname: "",
        lastname: "",
        email: "",
        role_id: "",
        phone: "",
        website_url: "",
        address: "",
        city: "",
        state: "",
        zip: "",
        country: "",
        bio: "",
        business_name: ""
    });
    const [edittrue, setEdittrue] = useState(false);

    const handleedittrue = () => {
        setEdittrue(!edittrue);
    }


    useEffect(() => {
        getDataById();
        getallcountry();
        getassignkitfunc()
    }, []);

    const getDataById = async (event) => {
        getreferralbyid({ _id: params.id }, event).then((res) => {
            console.log("res", res);
            if (res?.code === 200) {
                setUserdata(res.data.data);
                setUser_id(res.data.data._id);
                getprojectforfitter(res.data.data._id);
                getallstatefunc(res.data.data.country);
                getallcityfunc(res.data.data.state);
                setSelectedOption2(res.data.data.status === 1 ? "Active" : "Deactivate");
                setDbSelectedOption2(res.data.data.status === 1 ? "Active" : "Deactivate");
                // setSelectedOption3(res.data.data.location === 1 ? "International" : "Domestic");
                // setDbSelectedOption3(res.data.data.location === 1 ? "International" : "Domestic");



                // setSelectedOption5(res.data.data?.assign_kit === 2 ? "Assign Kit" : getassignkitname(res.data.data?.assign_kit));
                // setSelectKitId(res.data.data.assign_kit);
                // setdbselectkitid(res.data.data.assign_kit);


                // setSelectedOption4(res.data.data?.role_id === 9 ? "Assign Role" : res.data.data?.role_id === 8 ? "Fitter / Builder" : res.data.data?.role_id === 10 ? "Fitter / Party" : "Fitter / Coach");
                // setSelectRoleId(res.data.data.role_id);
                // setdbselectroleid(res.data.data.role_id);

                // setSelectedOption6(res.data.data?.party_id === 0 ? "Assign Party" : getPartykitname(res.data.data?.party_id));
                // setSelectedOptionid6(res.data.data.party_id);
                // setSelectedOptionDb6(res.data.data.party_id);

                setRole(res.data.data.role_id)
            } else {
                alert(res.data?.message);
            }
        }).catch((err) => {
            alert(err);
        })
    }

    const dataChange = (e) => {
        const { name, value } = e.target;
        setUserdata({ ...userdata, [name]: value });
    }

    const handleUpdateSubmit = async (e) => {
        e.preventDefault();
        userdata._id = user_id;
        updaterefferal(userdata, e).then((res) => {
            console.log(res);
            if (!res.data.status) {
                setErrors(res.data.error);
                alert(res.data.message);
            } else {
                getDataById();
            }
        }).catch((err) => {
            alert(err);
        }).finally(() => {
            setApicall(false);
            setEdittrue(false);
        });
        setValidated(true);
    }

    const getprojectforfitter = (id) => {
        setApicall(true);
        setIsLoading(true);

        const data = {
            _id: id
        }
        getprojectbyreferral(data).then((response) => {
            if (!response.data.status) {
                setErrors(response.data.error);
                console.log(response.data.message);
            } else {
                const data = response.data.data;
                setFilteredData(data);
                setDataNull(!null);
            }
        }).catch((err) => {
            console.log(err);
        }).finally(() => {
            setApicall(false);
            setValidated(true);
            setIsLoading(false);
        });
    };

    const handleCloseConfirmation2 = () => setShowConfirmation2(false);
    const handleShowConfirmation2 = () => setShowConfirmation2(true);
    const [showConfirmation2, setShowConfirmation2] = useState(false);

    const [rmvloader, setRmvloader] = useState(false);

    const removecustomerfunc = () => {
        handleCloseConfirmation2();
        setRmvloader(true);
        const data = {
            user_id: params.id
        }
        removefitter(data).then((response) => {
            if (!response.data.status) {
                console.log(response.data.message);
            } else {
                setRmvloader(false);
                const data = response.data.data;
                window.location.href = '/fitter_accounts';
            }
        }).catch((err) => {
            console.log(err);
        });
    }

    const [stateLoading, setStateLoading] = useState(false);
    const [cityLoading, setCityLoading] = useState(false);

    const [countrylist, setCountrylist] = useState([]);
    const [statelist, setStatelist] = useState([]);
    const [citylist, setCitylist] = useState([]);

    const getallcountry = () => {
        getcountriesforfitter()
            .then((response) => {
                if (!response.data.status) {
                    console.log(response.data.message);
                } else {
                    const data = response.data.data;
                    setCountrylist(data);
                }
            })
            .catch((err) => {
                console.log(err);
            });
    };

    const getallstatefunc = (country_id) => {
        setStateLoading(true)
        const data = {
            country_id: country_id,
        };
        getstates(data)
            .then((response) => {
                if (!response.data.status) {
                    console.log(response.data.message);
                } else {
                    setStateLoading(false)
                    const data = response.data.data;
                    setStatelist(data);
                }
            })
            .catch((err) => {
                console.log(err);
            });
    };

    const getallcityfunc = (state_id) => {
        setCityLoading(true);
        const data = {
            state_id: state_id,
        };
        getcities(data)
            .then((response) => {
                if (!response.data.status) {
                    console.log(response.data.message);
                } else {
                    setCityLoading(false);
                    const data = response.data.data;
                    setCitylist(data);
                }
            })
            .catch((err) => {
                console.log(err);
            });
    };

    const getColorClass = () => {
        const selectedColor = options2.find(opt => opt.text === selectedOption2)?.color;
        return selectedColor ? selectedColor : 'green';
    };

    const selectOption2 = (option) => {
        setSelectedOption2(option);
    };

    const selectOption3 = (option) => {
        setSelectedOption3(option.text);
        setSelectedOptionid3(option.id);
    };

    const updateStatusfunc = () => {
        setApicallupdate(true);
        const data = {
            _id: user_id,
            status: selectedOption2 === "Active" ? 1 : 0
        }
        activereferral(data).then((res) => {
            if (!res.data.status) {
                setErrors(res.data.error);
                alert(res.data.message);
            } else {
                getDataById();
                window.location.href = "/referrals"
            }
        }).catch((err) => {
            // alert(err);
            console.error(err);
        }
        ).finally(() => {
            setApicallupdate(false);
        });


    }

    const changelocationfunc = () => {
        setApicallupdate(true);
        const data = {
            _id: user_id,
            location: selectedOptionid3
        }
        updatelocation(data).then((res) => {
            if (!res.data.status) {
                setErrors(res.data.error);
                alert(res.data.message);
            } else {
                getDataById();
                window.location.href = "/fitter_accounts"
            }
        }).catch((err) => {
            // alert(err);
            console.error(err);
        }).finally(() => {
            setApicallupdate(false);
        });

    }

    const updatefitterrole = () => {
        setApicallupdate(true);

        const data = {
            _id: params.id,
            role_id: selectroleid
        }

        updatestaffrole(data).then((response) => {
            if (!response.data.status) {
                console.log(response.data.message);
            } else {
                getDataById();
                window.location.href = "/fitter_accounts"
            }
        }).catch((err) => {
            console.log(err);
        }).finally(() => {
            setApicallupdate(false);
            setValidated(true);
        });
    };

    const updatePartyKit = () => {
        setApicallupdate(true);

        const data = {
            _id: params.id,
            party_id: selectedOptionid6
        }

        updatepartykit(data).then((response) => {
            if (!response.data.status) {
                console.log(response.data.message);
            } else {
                getDataById();
                window.location.href = "/fitter_accounts"
            }
        }).catch((err) => {
            console.log(err);
        }).finally(() => {
            setApicallupdate(false);
            setValidated(true);
        });
    };

    const updateassingkit = () => {
        setApicallupdate(true);

        const data = {
            _id: params.id,
            assign_kit: selectkitid
        }

        staffassignkit(data).then((response) => {
            if (!response.data.status) {
                console.log(response.data.message);
            } else {
                getDataById();
                window.location.href = "/fitter_accounts"
            }
        }).catch((err) => {
            console.log(err);
        }).finally(() => {
            setApicallupdate(false);
            setValidated(true);
        });
    };

    return (
        <>
            {
                isLoading ? (
                    <div className="loading">
                        <Loader2 />
                    </div>
                ) : (
                    <>

                        <Modal
                            show={showConfirmation2}
                            onHide={handleCloseConfirmation2}
                            centered
                            id="success_tic"
                            className='model-thank-you'
                        >
                            <Modal.Body>
                                <div className="logo-modal mb-4 text-center">
                                    <img src={require('../assets/images/logo_text.png')} alt="logo" />
                                </div>
                                <div className="confirmation-content text-center">
                                    <h4>Are you sure you want to remove a fitter?</h4>
                                    <div className="confirmation-buttons d-flex align-items-center justify-content-between gap-2 mt-4">
                                        <Button variant="success" onClick={removecustomerfunc} style={{ maxWidth: "3.5rem" }}>Yes</Button>
                                        {' '}
                                        <Button variant="danger" onClick={() => {
                                            handleCloseConfirmation2();
                                        }} style={{ maxWidth: "3.5rem" }}>
                                            No
                                        </Button>
                                    </div>
                                </div>
                            </Modal.Body>
                        </Modal>
                        <div className="main-page-body-content-header">
                            <HeaderAdmin />
                        </div>
                        <div className="dashboard-container d-flex dashboard_light project_dashboard_sec build_box_dashboard_sec">
                            <div className="main-container">
                                <div className="main-page-body-content">
                                    <div className="main-page-body-content-body">
                                        <div className="main-page-body-content-body-container">
                                            <div className="container-fluid">
                                                <div className="sec-dashboard-header-title">
                                                    <div className="sec-header-new">
                                                        <button type="button" className="btn-header-transparent">
                                                            <div className="border_box_view">
                                                                <div className="border_box_view_inner">
                                                                    <div className="box_icon">
                                                                        <svg viewBox="-42 0 512 512.002" xmlns="http://www.w3.org/2000/svg" fill="#99ea24"><path d="m210.351562 246.632812c33.882813 0 63.222657-12.152343 87.195313-36.128906 23.972656-23.972656 36.125-53.304687 36.125-87.191406 0-33.875-12.152344-63.210938-36.128906-87.191406-23.976563-23.96875-53.3125-36.121094-87.191407-36.121094-33.886718 0-63.21875 12.152344-87.191406 36.125s-36.128906 53.308594-36.128906 87.1875c0 33.886719 12.15625 63.222656 36.132812 87.195312 23.976563 23.96875 53.3125 36.125 87.1875 36.125zm0 0" /><path d="m426.128906 393.703125c-.691406-9.976563-2.089844-20.859375-4.148437-32.351563-2.078125-11.578124-4.753907-22.523437-7.957031-32.527343-3.308594-10.339844-7.808594-20.550781-13.371094-30.335938-5.773438-10.15625-12.554688-19-20.164063-26.277343-7.957031-7.613282-17.699219-13.734376-28.964843-18.199219-11.226563-4.441407-23.667969-6.691407-36.976563-6.691407-5.226563 0-10.28125 2.144532-20.042969 8.5-6.007812 3.917969-13.035156 8.449219-20.878906 13.460938-6.707031 4.273438-15.792969 8.277344-27.015625 11.902344-10.949219 3.542968-22.066406 5.339844-33.039063 5.339844-10.972656 0-22.085937-1.796876-33.046874-5.339844-11.210938-3.621094-20.296876-7.625-26.996094-11.898438-7.769532-4.964844-14.800782-9.496094-20.898438-13.46875-9.75-6.355468-14.808594-8.5-20.035156-8.5-13.3125 0-25.75 2.253906-36.972656 6.699219-11.257813 4.457031-21.003906 10.578125-28.96875 18.199219-7.605469 7.28125-14.390625 16.121094-20.15625 26.273437-5.558594 9.785157-10.058594 19.992188-13.371094 30.339844-3.199219 10.003906-5.875 20.945313-7.953125 32.523437-2.058594 11.476563-3.457031 22.363282-4.148437 32.363282-.679688 9.796875-1.023438 19.964844-1.023438 30.234375 0 26.726562 8.496094 48.363281 25.25 64.320312 16.546875 15.746094 38.441406 23.734375 65.066406 23.734375h246.53125c26.625 0 48.511719-7.984375 65.0625-23.734375 16.757813-15.945312 25.253906-37.585937 25.253906-64.324219-.003906-10.316406-.351562-20.492187-1.035156-30.242187zm0 0" /></svg>
                                                                    </div>
                                                                    <div className="box_text_content">
                                                                        <div className="big_text">{userdata.fullname}</div>
                                                                    </div>
                                                                </div>
                                                            </div>
                                                        </button>
                                                        <div className="header-left">
                                                            <div className="header-left-inner">
                                                                <button type="button" className="btn-header-transparent close-icon" onClick={goBack}>
                                                                    <div className="border_box_view">
                                                                        <div className="border_box_view_inner">
                                                                            <div className="box_icon">
                                                                                <IoCloseSharp />
                                                                            </div>
                                                                        </div>
                                                                    </div>
                                                                </button>
                                                            </div>
                                                        </div>
                                                    </div>
                                                </div>
                                                <div className="dashboard-sec">
                                                    <div className="row">
                                                        <div className="col-lg-6 col-md-12 col-sm-12 order-md-2 order-sm-2 order-2  design_hide_mobile">
                                                            <>
                                                                {
                                                                    filteredData.length === 0 ? (
                                                                        <div className="black_bg_box mt-0">
                                                                            <div className='no-data-img'>
                                                                                <img src={require("../assets/images/logo_text.png")} alt="" />
                                                                            </div>
                                                                            <div className="no-data-text">
                                                                                <h3>No projects to show</h3>
                                                                            </div>
                                                                        </div>
                                                                    ) : (
                                                                        filteredData && filteredData.map((item, i) => {
                                                                            return (
                                                                                <div className="black_bg_box mt-0">
                                                                                    <div className="black_bg_box_inner">
                                                                                        <div className="left_box_content">
                                                                                            <div className="list_border_boxs project-list-box">
                                                                                                <div className="border_box_view">
                                                                                                    <div className="border_box_view_inner">
                                                                                                        <div className="box_icon">
                                                                                                            {getsvgicon(item.current_stage)}
                                                                                                        </div>
                                                                                                        <div className="box_text_content">
                                                                                                            <div className="little_text">Status:</div>
                                                                                                            <div className="big_text">
                                                                                                                {item && getcurrentstage(item.current_stage)}
                                                                                                            </div>
                                                                                                        </div>
                                                                                                    </div>
                                                                                                </div>
                                                                                                <div className="border_box_view">
                                                                                                    <div className="border_box_view_inner">
                                                                                                        <div className="box_icon">
                                                                                                            <FaCalendarAlt />
                                                                                                        </div>
                                                                                                        <div className="box_text_content">
                                                                                                            <div className="little_text">Start Date:</div>
                                                                                                            <div className="big_text">{item && formatDate(item.createdAt)}</div>
                                                                                                        </div>
                                                                                                    </div>
                                                                                                </div>
                                                                                            </div>
                                                                                        </div>
                                                                                        <div className="right_box_content">
                                                                                            <div className="box_btn">
                                                                                                <Link to={`/remote_inquirie_view/${item._id}`}>
                                                                                                    <button className="btn customer_btn_view"><IoMdEye /></button>
                                                                                                </Link>
                                                                                            </div>
                                                                                        </div>
                                                                                    </div>
                                                                                </div>
                                                                            );
                                                                        })
                                                                    )
                                                                }
                                                            </>
                                                        </div>
                                                        <div className={`col-lg-6 col-md-12 col-sm-12 order-md-1 order-sm-1 order-1 right_fix_sec ${scrolled ? 'tab_fix' : ''}`}>
                                                            <div className="container-fluid">
                                                                <div className="row ">
                                                                    <div className='col-md-12 col-12 select-dropdown-build mt-0 ps-0'>
                                                                        <div className={`select-options-dropdown ${isOpen2 ? 'open' : ''}`}>
                                                                            <div className='select-option-inner' onClick={toggleDropdown2} >
                                                                                <span className={`icon-color color-${getColorClass()}`}></span>
                                                                                <div className='selected-option-text'>{selectedOption2}</div>
                                                                                <span className={`icon ${isOpen2 ? 'up' : 'down'}`}>
                                                                                    <i className="bi bi-chevron-down" />
                                                                                </span>
                                                                            </div>

                                                                            {isOpen2 && (
                                                                                <div className='option-list buildsheet-option-list'>
                                                                                    <div className='drop-down-list'>
                                                                                        {options2.map(option => (
                                                                                            <div
                                                                                                key={option.text}
                                                                                                className={`drop-down-item ${selectedOption2 === option.text ? 'active' : ''}`}
                                                                                                onClick={() => selectOption2(option.text)}
                                                                                            >
                                                                                                <div className='drop-down-item-icon'>
                                                                                                    <span className={`icon-color color-${option.color}`}> </span>
                                                                                                </div>
                                                                                                <div className='drop-down-item-text'>{option.text}</div>
                                                                                            </div>
                                                                                        ))}
                                                                                    </div>
                                                                                    <div className='form-box-section'>
                                                                                        {
                                                                                            dbselectedOption2 !== selectedOption2 ? (<button
                                                                                                className="btn btn-primary btn-create"
                                                                                                onClick={updateStatusfunc}
                                                                                            >{apicallupate ? (<Spinner animation="border" className="border-black" />) : (<span>Update Status</span>)}
                                                                                            </button>) : (<button
                                                                                                className="btn btn-primary btn-create"
                                                                                                disabled
                                                                                            ><span>Update Status</span></button>)
                                                                                        }
                                                                                    </div>
                                                                                </div>
                                                                            )}
                                                                        </div>
                                                                    </div>
                                                                    {/* <div className="col-md-6 col-12 select-dropdown-build mt-0 interfix">
                                                                        <div className={`select-options-dropdown ${isOpen3 ? 'open' : ''}`}>
                                                                            <div className='select-option-inner' onClick={toggleDropdown3} >
                                                                                <div className='selected-option-text'>{selectedOption3}</div>
                                                                                <span className={`icon ${isOpen3 ? 'up' : 'down'}`}>
                                                                                    <i className="bi bi-chevron-down" />
                                                                                </span>
                                                                            </div>
                                                                            {isOpen3 && (
                                                                                <div className='option-list buildsheet-option-list'>
                                                                                    <div className='drop-down-list'>
                                                                                        {options3.map(option => (
                                                                                            <div
                                                                                                key={option.text}
                                                                                                className={`drop-down-item ${selectedOption3 === option.text ? 'active' : ''}`}
                                                                                                onClick={() => selectOption3(option)}
                                                                                            >
                                                                                                <div className='drop-down-item-text'>{option.text}</div>
                                                                                            </div>
                                                                                        ))}
                                                                                    </div>
                                                                                    <div className='form-box-section'>
                                                                                        {
                                                                                            dbselectedOption3 !== selectedOption3 ? (
                                                                                                <button
                                                                                                    className="btn btn-primary btn-create"
                                                                                                    onClick={changelocationfunc}
                                                                                                >{apicallupate ? (<Spinner animation="border" className="border-black" />) : (<span>Update Status</span>)}
                                                                                                </button>) :
                                                                                                (<button
                                                                                                    className="btn btn-primary btn-create"
                                                                                                    disabled
                                                                                                ><span>Update Status</span></button>)
                                                                                        }
                                                                                    </div>
                                                                                </div>
                                                                            )}
                                                                        </div>
                                                                    </div>  */}
                                                                </div>
                                                                {/* <div className="row">
                                                                    <div className='col-md-12 col-12 select-dropdown-build mt-0 ps-0'>
                                                                        <div className={`select-options-dropdown ${isOpen4 ? 'open' : ''}`}> 
                                                                            <div className='select-option-inner' >
                                                                                <div className='selected-option-text'>{selectedOption4}</div>
                                                                                <span className={`icon ${isOpen4 ? 'up' : 'down'}`}>
                                                                                    <i className="bi bi-chevron-down" />
                                                                                </span>
                                                                            </div>

                                                                            {isOpen4 && (
                                                                                <div className='option-list buildsheet-option-list'>
                                                                                    <div className='drop-down-list'>
                                                                                        {options4.map(option => (
                                                                                            <div
                                                                                                key={option.text}
                                                                                                className={`drop-down-item ${selectedOption4 === option.text ? 'active' : ''}`}
                                                                                                onClick={() => selectOption4(option)}
                                                                                            >
                                                                                                <div className='drop-down-item-text'>{option.text}</div>
                                                                                            </div>
                                                                                        ))}
                                                                                    </div>
                                                                                    <div className='form-box-section'>
                                                                                        {
                                                                                            // selectedOption2 === "Inquiry" || selectionid === dbselectionid ? (
                                                                                            selectroleid === dbselectroleid ? (
                                                                                                <button
                                                                                                    className="btn btn-primary btn-create"
                                                                                                    disabled
                                                                                                >
                                                                                                    <span>Update Status</span>
                                                                                                </button>
                                                                                            ) : (
                                                                                                <button
                                                                                                    className="btn btn-primary btn-create"
                                                                                                    onClick={updatefitterrole}
                                                                                                >

                                                                                                    {apicallupate ? (<Spinner animation="border" className="border-black" />) : (<span>Update Status</span>)}
                                                                                                </button>
                                                                                            )
                                                                                        }

                                                                                    </div>
                                                                                </div>
                                                                            )}
                                                                        </div>
                                                                    </div>
                                                                </div>
                                                                <div className="row">
                                                                    <div className="col-md-12 col-12 select-dropdown-build mt-0 ps-0">
                                                                        <div className={`select-options-dropdown ${isOpen5 ? 'open' : ''}`}>
                                                                            <div className='select-option-inner' onClick={toggleDropdown5} >
                                                                                <div className='selected-option-text'>{selectedOption5}</div>
                                                                                <span className={`icon ${isOpen5 ? 'up' : 'down'}`}>
                                                                                    <i className="bi bi-chevron-down" />
                                                                                </span>
                                                                            </div>

                                                                            {isOpen5 && (
                                                                                <div className='option-list buildsheet-option-list'>
                                                                                    <div className='drop-down-list'>
                                                                                        {options5.map(option => (
                                                                                            <div
                                                                                                key={option.text}
                                                                                                className={`drop-down-item ${selectedOption5 === option.text ? 'active' : ''}`}
                                                                                                onClick={() => selectOption5(option)}
                                                                                            >
                                                                                                <div className='drop-down-item-text'>{option.text}</div>
                                                                                            </div>
                                                                                        ))}
                                                                                    </div>
                                                                                    <div className='form-box-section'>
                                                                                        {
                                                                                            // selectedOption2 === "Inquiry" || selectionid === dbselectionid ? (
                                                                                            selectkitid === dbselectkitid ? (
                                                                                                <button
                                                                                                    className="btn btn-primary btn-create"
                                                                                                    disabled
                                                                                                >
                                                                                                    <span>Update Status</span>
                                                                                                </button>
                                                                                            ) : (
                                                                                                <button
                                                                                                    className="btn btn-primary btn-create"
                                                                                                    onClick={updateassingkit}
                                                                                                >

                                                                                                    {apicallupate ? (<Spinner animation="border" className="border-black" />) : (<span>Update Status</span>)}
                                                                                                </button>
                                                                                            )
                                                                                        }

                                                                                    </div>
                                                                                </div>
                                                                            )}
                                                                        </div>
                                                                    </div>
                                                                </div> */}


                                                            </div>
                                                            <div className="fix_sec_view  fitter-single-page container-fluid ps-0">
                                                                <div className="tab-container tab-club-fitting">
                                                                    <Tabs
                                                                        defaultActiveKey="info"
                                                                        id="uncontrolled-tab-example"
                                                                        className="club-fitting-tab tab_new_customer two-tab-design design_hide_desktop"
                                                                    >
                                                                        <Tab eventKey="info" title="Info">
                                                                            <div className="tab-box-section">
                                                                                <Form noValidate validated={validated} onSubmit={handleUpdateSubmit}>
                                                                                    <div className="tab-form-header mb-5">
                                                                                        <h3>Information</h3>
                                                                                        {
                                                                                            edittrue ? (
                                                                                                apicall ? (
                                                                                                    <button className="btn btn-save">
                                                                                                        <Spinner animation="border" className="border-black" />
                                                                                                    </button>
                                                                                                ) : (
                                                                                                    <div className="sec-btn-group d-flex justify-content-end">
                                                                                                        <button className="btn tab_form_btn save_btn" type="submit">Save</button>
                                                                                                    </div>
                                                                                                )
                                                                                            ) : (
                                                                                                <button className="btn tab_form_btn" onClick={handleedittrue}>Edit</button>
                                                                                            )
                                                                                        }
                                                                                    </div>
                                                                                    <div className="row gx-2">
                                                                                        <fieldset>
                                                                                            <div className="row">
                                                                                                <div className="col-md-12 form-group" controlid="validationCustom01">
                                                                                                    <input type="text"
                                                                                                        className="form-control dashboard-input-box-3"
                                                                                                        placeholder="First name"
                                                                                                        required
                                                                                                        disabled={!edittrue}
                                                                                                        value={userdata.fullname}
                                                                                                        onChange={(e) => dataChange(e)}
                                                                                                        name={"fullname"}
                                                                                                    />
                                                                                                    <Form.Control.Feedback type="invalid">
                                                                                                        Please enter a fullname.
                                                                                                    </Form.Control.Feedback>
                                                                                                </div>
                                                                                                {/* <div className="col-md-6 form-group" controlid="validationCustom02">
                                                                                                    <input
                                                                                                        type="text"
                                                                                                        name="lastname"
                                                                                                        className="form-control dashboard-input-box-3"
                                                                                                        placeholder="Last name"
                                                                                                        required
                                                                                                        value={userdata.lastname}
                                                                                                        onChange={(e) => dataChange(e)}
                                                                                                        disabled={!edittrue}
                                                                                                    />
                                                                                                    <Form.Control.Feedback type="invalid">
                                                                                                        Please enter a last name.
                                                                                                    </Form.Control.Feedback>
                                                                                                </div> */}
                                                                                            </div>
                                                                                            {/* <div className="col-md-12 form-group" controlid="validationCustom03">
                                                                                                <input type="tel" className="form-control dashboard-input-box-3"
                                                                                                    name={"business_name"}
                                                                                                    required
                                                                                                    placeholder="Business Name"
                                                                                                    disabled={!edittrue}
                                                                                                    value={userdata.business_name}
                                                                                                    onChange={(e) => dataChange(e)}
                                                                                                />
                                                                                            </div> */}
                                                                                            <div className="col-md-12 form-group" controlid="validationCustom03">
                                                                                                <input type="tel" className="form-control dashboard-input-box-3"
                                                                                                    name={"phone"}
                                                                                                    required
                                                                                                    placeholder="Phone Number"
                                                                                                    disabled={!edittrue}
                                                                                                    value={userdata.phone}
                                                                                                    onChange={(e) => dataChange(e)}
                                                                                                />
                                                                                                <Form.Control.Feedback type="invalid">
                                                                                                    Please enter a 8-digit phone number.
                                                                                                </Form.Control.Feedback>
                                                                                            </div>
                                                                                            <div className="col-md-12 form-group" controlid="validationCustom04">
                                                                                                <input type="email" className="form-control dashboard-input-box-3"
                                                                                                    name="email"
                                                                                                    placeholder="Email"
                                                                                                    disabled={!edittrue}
                                                                                                    value={userdata.email}
                                                                                                    onChange={(e) => dataChange(e)}
                                                                                                />
                                                                                                <Form.Control.Feedback type="invalid">
                                                                                                    Please choose a email.
                                                                                                </Form.Control.Feedback>
                                                                                            </div>
                                                                                            {/* <div className="col-md-12 form-group" controlid="validationCustom04">
                                                                                                <input type="text" className="form-control dashboard-input-box-3"
                                                                                                    disabled={!edittrue}
                                                                                                    value={userdata.website_url}
                                                                                                    onChange={(e) => dataChange(e)}
                                                                                                    name="website_url"
                                                                                                    placeholder="Website URL..." />
                                                                                                <Form.Control.Feedback type="invalid">
                                                                                                    Please choose a website.
                                                                                                </Form.Control.Feedback>
                                                                                            </div>
                                                                                            <div className="col-md-12 form-group" controlid="validationCustom04">
                                                                                                <input
                                                                                                    type="text"
                                                                                                    className="form-control dashboard-input-box-3"
                                                                                                    disabled={!edittrue}
                                                                                                    name="address"
                                                                                                    placeholder="Shipping Address"
                                                                                                    required
                                                                                                    value={userdata.address}
                                                                                                    onChange={dataChange}
                                                                                                // style={{ height: '100px' }}
                                                                                                />
                                                                                                <Form.Control.Feedback type="invalid">
                                                                                                    Please choose a street address.
                                                                                                </Form.Control.Feedback>
                                                                                            </div>

                                                                                            <div className="row">
                                                                                                <div className="col-md-6 form-group" controlid="validationCustom01">
                                                                                                    <select name="country" disabled={!edittrue} value={userdata.country} onChange={(e) => {
                                                                                                        dataChange(e);
                                                                                                        setUserdata((prev) => ({
                                                                                                            ...prev,
                                                                                                            state: "",
                                                                                                            city: "",
                                                                                                        }));
                                                                                                        getallstatefunc(
                                                                                                            e.target.value
                                                                                                        );
                                                                                                    }}
                                                                                                        class="form-select form-control dashboard-input-box-3 select-custom-boxx"
                                                                                                        aria-label="Default select example"
                                                                                                    >
                                                                                                        <option value={0}>
                                                                                                            Country
                                                                                                        </option>
                                                                                                        {countrylist &&
                                                                                                            countrylist.map(
                                                                                                                (item) => (
                                                                                                                    <option
                                                                                                                        value={item._id}
                                                                                                                        key={item._id}
                                                                                                                    >
                                                                                                                        {item.name}
                                                                                                                    </option>
                                                                                                                )
                                                                                                            )}
                                                                                                    </select>
                                                                                                </div>
                                                                                                <div className="col-md-6 form-group" controlid="validationCustom02">
                                                                                                    <select name="state" disabled={!edittrue} value={userdata.state} onChange={(e) => {
                                                                                                        dataChange(e);
                                                                                                        getallcityfunc(
                                                                                                            e.target.value
                                                                                                        );
                                                                                                    }}
                                                                                                        class="form-select form-control dashboard-input-box-3 select-custom-boxx"
                                                                                                        aria-label="Default select example"
                                                                                                    > 
                                                                                                        {stateLoading ? (
                                                                                                            <option disabled>Loading...</option>
                                                                                                        ) : (
                                                                                                            <>
                                                                                                                <option value={0}>State</option>
                                                                                                                {statelist &&
                                                                                                                    statelist.map((item) => (
                                                                                                                        <option value={item._id} key={item._id}>
                                                                                                                            {item.name}
                                                                                                                        </option>
                                                                                                                    ))}
                                                                                                            </>
                                                                                                        )}
                                                                                                    </select>
                                                                                                </div>
                                                                                            </div>
                                                                                            <div className="row">
                                                                                                <div className="col-md-6 form-group " controlid="validationCustom02">
                                                                                                    <select name="city" disabled={!edittrue} value={userdata.city} onChange={(e) => { dataChange(e); }}
                                                                                                        class="form-select form-control dashboard-input-box-3 select-custom-boxx" aria-label="Default select example">
                                                                                                 
                                                                                                        {cityLoading ? (
                                                                                                            <option disabled>Loading...</option>
                                                                                                        ) : (
                                                                                                            <>
                                                                                                                <option value={0}>City/Town</option>
                                                                                                                {citylist &&
                                                                                                                    citylist.map((item) => (
                                                                                                                        <option value={item._id} key={item._id}>
                                                                                                                            {item.name}
                                                                                                                        </option>
                                                                                                                    ))}
                                                                                                            </>
                                                                                                        )}
                                                                                                    </select>
                                                                                                </div>
                                                                                                <div className="col-md-6 form-group " controlid="validationCustom02">
                                                                                                    <input type="text" name="zip"
                                                                                                        disabled={!edittrue}
                                                                                                        value={userdata.zip || ""}
                                                                                                        onChange={(e) => dataChange(e)}
                                                                                                        className="form-control dashboard-input-box-3" placeholder="Zip Code" />
                                                                                                    <Form.Control.Feedback type="invalid">
                                                                                                        Please enter Zip Code
                                                                                                    </Form.Control.Feedback>
                                                                                                </div>
                                                                                            </div>
                                                                                            <div className="row">
                                                                                                <div className="col-md-12 form-group mb-0" controlid="validationCustom02">
                                                                                                    <textarea type="text" className="form-control dashboard-input-box-3"
                                                                                                        disabled={!edittrue}
                                                                                                        value={userdata?.bio || ""}
                                                                                                        onChange={(e) => dataChange(e)}
                                                                                                        name="bio" placeholder="Bio..." style={{ height: '100px' }} />
                                                                                                </div>
                                                                                            </div> */}
                                                                                        </fieldset>
                                                                                    </div>
                                                                                </Form>
                                                                            </div>
                                                                            {/* <div className="btn-box-section btn-inline-box mb-5">
                                                                                {
                                                                                    rmvloader ? (<button className="btn btn-primary btn-remove" disabled>Removing...</button>) : (<button className="btn btn-primary btn-remove" onClick={handleShowConfirmation2}>Remove Fitter</button>)
                                                                                }

                                                                            </div> */}
                                                                        </Tab>
                                                                        <Tab eventKey="project" title="Projects">
                                                                            <div className=" ">
                                                                                <>
                                                                                    {
                                                                                        filteredData.length === 0 ? (
                                                                                            <div className="black_bg_box mt-0">
                                                                                                <div className='no-data-img'>
                                                                                                    <img src={require("../assets/images/logo_text.png")} alt="" />
                                                                                                </div>
                                                                                                <div className="no-data-text">
                                                                                                    <h3>No projects to show</h3>
                                                                                                </div>
                                                                                            </div>
                                                                                        ) : (
                                                                                            filteredData && filteredData.map((item, i) => {
                                                                                                return (
                                                                                                    <div className="black_bg_box mt-0">
                                                                                                        <div className="black_bg_box_inner">
                                                                                                            <div className="left_box_content">
                                                                                                                <div className="list_border_boxs project-list-box">
                                                                                                                    <div className="border_box_view">
                                                                                                                        <div className="border_box_view_inner">
                                                                                                                            <div className="box_icon">
                                                                                                                                {getsvgicon(item.current_stage)}
                                                                                                                            </div>
                                                                                                                            <div className="box_text_content">
                                                                                                                                <div className="little_text">Status:</div>
                                                                                                                                <div className="big_text">
                                                                                                                                    {item && getcurrentstage(item.current_stage)}
                                                                                                                                </div>
                                                                                                                            </div>
                                                                                                                        </div>
                                                                                                                    </div>
                                                                                                                    <div className="border_box_view">
                                                                                                                        <div className="border_box_view_inner">
                                                                                                                            <div className="box_icon">
                                                                                                                                <FaCalendarAlt />
                                                                                                                            </div>
                                                                                                                            <div className="box_text_content">
                                                                                                                                <div className="little_text">Start Date:</div>
                                                                                                                                <div className="big_text">{item && formatDate(item.createdAt)}</div>
                                                                                                                            </div>
                                                                                                                        </div>
                                                                                                                    </div>
                                                                                                                </div>
                                                                                                            </div>
                                                                                                            <div className="right_box_content">
                                                                                                                <div className="box_btn">
                                                                                                                    <Link to={`/remote_inquirie_view/${item._id}`}>
                                                                                                                        <button className="btn customer_btn_view"><IoMdEye /></button>
                                                                                                                    </Link>
                                                                                                                </div>
                                                                                                            </div>
                                                                                                        </div>
                                                                                                    </div>
                                                                                                );
                                                                                            })
                                                                                        )
                                                                                    }
                                                                                </>
                                                                            </div>
                                                                        </Tab>
                                                                    </Tabs>
                                                                </div>
                                                            </div>
                                                        </div>
                                                    </div>
                                                </div>
                                            </div>
                                        </div>
                                    </div>
                                </div>
                            </div >
                        </div >
                    </>
                )
            }
        </>
    );
}


const getcurrentstage = (current_stage) => {
    switch (current_stage) {
        case '0':
            return 'Fitting';
        case '1':
            return 'Perscription';
        case '2':
            return 'Build sheet';
        case '3':
            return 'Staging station';
        case '4':
            return 'Build station';
        case '5':
            return 'Ship station';
        case '6':
            return 'Complete';
        default:
            return ''; // In case the status doesn't match any case
    }
};

const formatDate = (dateString) => {
    const date = new Date(dateString);
    const month = String(date.getUTCMonth() + 1).padStart(2, '0'); // Months are zero-indexed
    const day = String(date.getUTCDate()).padStart(2, '0');
    const year = String(date.getUTCFullYear()).slice(-2);
    return `${month}/${day}/${year}`;
};

const getassignkitname = (kitname) => {
    switch (kitname) {
        case 0:
            return "Righty";
        case 1:
            return "Lefty";
        case 3:
            return "TPT";
        case 4:
            return "Tall";
        case 5:
            return "Junior";
        case 6:
            return "Biz Dev";
        default:
            return "Assign Kit";
    }

}

const getPartykitname = (kitname) => {
    switch (kitname) {
        case 1:
            return "Party1";
        // case 2:
        //     return "Party2 - Lefty Legends";
        // case 3:
        //     return "Party3 - TPT Titans";
        // case 4:
        //     return "Party4 - Tall Masters";
        // case 5:
        //     return "Party5 - Junior Champs";
        default:
            return "Assign Kit";
    }

}


const getsvgicon = (current_stage) => {
    switch (current_stage) {
        case '0':
            return (
                <svg fill="none" height="64" viewBox="0 0 64 64" width="64" xmlns="http://www.w3.org/2000/svg"><g fill="#99ea24"><path d="m25 2c-3.866 0-7 3.13401-7 7 0 3.866 3.134 7 7 7h14c3.866 0 7-3.134 7-7 0-3.86599-3.134-7-7-7z" /><path clip-rule="evenodd" d="m15 9.00001c0-.6707.066-1.32598.1919-1.9597-4.0388.40511-7.1919 3.81419-7.1919 7.95969v39c0 4.4183 3.5817 8 8 8h32c4.4183 0 8-3.5817 8-8v-39c0-4.1455-3.1531-7.55458-7.1919-7.95968.1259.63371.1919 1.28899.1919 1.95969 0 5.52289-4.4771 9.99999-10 9.99999h-14c-5.5228 0-10-4.4771-10-9.99999zm13.4142 18.58579c.7811.781.7811 2.0474 0 2.8284l-6 6c-.432.4321-1.0379.6429-1.6448.5725-.6069-.0705-1.1483-.4145-1.4699-.934l-2-3.2308c-.5814-.9391-.2914-2.1718.6478-2.7532s2.1718-.2913 2.7532.6478l.6709 1.0837 4.2144-4.2144c.781-.7811 2.0474-.7811 2.8284 0zm6.5858 1.4142c-1.1046 0-2 .8954-2 2s.8954 2 2 2h10c1.1046 0 2-.8954 2-2s-.8954-2-2-2zm-2 15c0-1.1046.8954-2 2-2h10c1.1046 0 2 .8954 2 2s-.8954 2-2 2h-10c-1.1046 0-2-.8954-2-2zm-4.5858.4142c.7811-.781.7811-2.0474 0-2.8284-.781-.7811-2.0474-.7811-2.8284 0l-4.2144 4.2144-.6709-1.0837c-.5814-.9391-1.814-1.2292-2.7532-.6478s-1.2292 1.8141-.6478 2.7532l2 3.2308c.3216.5195.863.8635 1.4699.934.6069.0704 1.2128-.1404 1.6448-.5725z" fill-rule="evenodd" /></g></svg>
            );
        case '1':
            return (
                <svg xmlns="http://www.w3.org/2000/svg" fill="none" height="64" viewBox="0 0 64 64" width="64"><g fill="#99ea24"><path d="m24 2c-3.866 0-7 3.13401-7 7 0 3.866 3.134 7 7 7h14c3.866 0 7-3.134 7-7 0-3.86599-3.134-7-7-7z" /><g clip-rule="evenodd" fill-rule="evenodd"><path d="m14.4096 6.15808c-.2665.90082-.4096 1.85466-.4096 2.84191 0 5.52281 4.4772 10.00001 10 10.00001h14c5.5229 0 10-4.4772 10-10.00001 0-.98725-.1431-1.94109-.4096-2.84191 3.6564.73752 6.4096 3.96822 6.4096 7.84192v22.2481c-1.8374-.8028-3.8667-1.2481-6-1.2481-8.2843 0-15 6.7157-15 15 0 2.9412.8465 5.6846 2.3091 8h-19.3091c-4.4183 0-8-3.5817-8-8v-36c0-3.8737 2.7532-7.1044 6.4096-7.84192zm3.5904 19.84192c0-1.1046.8954-2 2-2h24c1.1046 0 2 .8954 2 2s-.8954 2-2 2h-24c-1.1046 0-2-.8954-2-2zm2 6c-1.1046 0-2 .8954-2 2s.8954 2 2 2h14c1.1046 0 2-.8954 2-2s-.8954-2-2-2zm-2 10c0-1.1046.8954-2 2-2h10c1.1046 0 2 .8954 2 2s-.8954 2-2 2h-10c-1.1046 0-2-.8954-2-2z" /><path d="m48 38c-6.6274 0-12 5.3726-12 12s5.3726 12 12 12 12-5.3726 12-12-5.3726-12-12-12zm0 18.0004c-1.1046 0-2-.8955-2-2v-2.0003h-2c-1.1046 0-2-.8954-2-2 0-1.1045.8954-2 2-2h2v-1.9997c0-1.1046.8954-2 2-2s2 .8954 2 2v1.9997h2c1.1046 0 2 .8955 2 2 0 1.1046-.8954 2-2 2h-2v2.0003c0 1.1045-.8954 2-2 2z" /></g></g></svg>
            );
        case '2':
            return (<svg xmlns="http://www.w3.org/2000/svg" fill="none" height="64" viewBox="0 0 64 64" width="64"><g fill="#99ea24"><path d="m15 9c0-3.86599 3.134-7 7-7h15c3.866 0 7 3.13401 7 7 0 3.866-3.134 7-7 7h-15c-3.866 0-7-3.134-7-7z" /><path d="m13 9c0-.68739.0771-1.35678.223-2h-.223c-4.41828 0-8 3.5817-8 8v39c0 4.4183 3.58172 8 8 8h12v-21c0-4.9706 4.0294-9 9-9h20v-17c0-4.4183-3.5817-8-8-8h-.223c.1459.64322.223 1.31261.223 2 0 4.9706-4.0294 9-9 9h-15c-4.9706 0-9-4.0294-9-9z" /><path clip-rule="evenodd" d="m35.2143 34c-4.4699 0-8.2143 3.5162-8.2143 8v12c0 4.4838 3.7444 8 8.2143 8h15.5714c4.4699 0 8.2143-3.5162 8.2143-8v-12c0-4.4838-3.7444-8-8.2143-8zm2.7857 4h10v4c0 1.1046-.8954 2-2 2h-6c-1.1046 0-2-.8954-2-2z" fill-rule="evenodd" /></g></svg>);
        case '3':
            return (<svg xmlns="http://www.w3.org/2000/svg" fill="none" height="64" viewBox="0 0 64 64" width="64"><g clip-rule="evenodd" fill="#99ea24" fill-rule="evenodd"><path d="m6.08372 8.06081c1.57579-3.67684 5.19118-6.06081 9.19148-6.06081h25.4496c4.0003 0 7.6157 2.38397 9.1915 6.06081l4.0837 9.52869v11.1718c-2.4315-1.1303-5.142-1.7613-8-1.7613-10.4934 0-19 8.5066-19 19 0 2.858.631 5.5685 1.7613 8h-14.7613c-6.62742 0-12-5.3726-12-12v-24.4105zm9.19148-2.06081c-2.4002 0-4.5694 1.43038-5.5149 3.63648l-2.72722 6.36352h18.96692v-10zm14.7248 0v10h18.9669l-2.7272-6.36351c-.9455-2.20611-3.1147-3.63649-5.5149-3.63649zm-11 37c0-1.1046-.8954-2-2-2h-5c-1.1046 0-2 .8954-2 2s.8954 2 2 2h5c1.1046 0 2-.8954 2-2z" /><path d="m46 30c-8.8366 0-16 7.1634-16 16s7.1634 16 16 16 16-7.1634 16-16-7.1634-16-16-16zm2 10c0-1.1046-.8954-2-2-2s-2 .8954-2 2v6.5c0 1.1046.8954 2 2 2h6.5c1.1046 0 2-.8954 2-2s-.8954-2-2-2h-4.5z" /></g></svg>);
        case '4':
            return (<svg xmlns="http://www.w3.org/2000/svg" fill="none" height="64" viewBox="0 0 64 64" width="64"><g clip-rule="evenodd" fill="#99ea24" fill-rule="evenodd"><path d="m15.2752 2c-4.0003 0-7.61569 2.38397-9.19148 6.06081l-4.08372 9.52869v24.4105c0 6.6274 5.37258 12 12 12h14.7613c-1.1303-2.4315-1.7613-5.142-1.7613-8 0-10.4934 8.5066-19 19-19 2.858 0 5.5685.631 8 1.7613v-11.1718l-4.0837-9.52869c-1.5758-3.67684-5.1912-6.06081-9.1915-6.06081zm-5.5149 7.63648c.9455-2.2061 3.1147-3.63648 5.5149-3.63648h10.7248v10h-18.96692zm20.2397 6.36352v-10h10.7248c2.4002 0 4.5694 1.43038 5.5149 3.63649l2.7272 6.36351zm-13 25c1.1046 0 2 .8954 2 2s-.8954 2-2 2h-5c-1.1046 0-2-.8954-2-2s.8954-2 2-2z" /><path d="m30 46c0-8.8366 7.1634-16 16-16s16 7.1634 16 16-7.1634 16-16 16-16-7.1634-16-16zm24 0c0 1.1046-.8954 2-2 2h-4v4c0 1.1046-.8954 2-2 2s-2-.8954-2-2v-4h-4c-1.1046 0-2-.8954-2-2s.8954-2 2-2h4v-4c0-1.1046.8954-2 2-2s2 .8954 2 2v4h4c1.1046 0 2 .8954 2 2z" /></g></svg>);
        case '5':
            return (<svg xmlns="http://www.w3.org/2000/svg" fill="none" height="64" viewBox="0 0 64 64" width="64"><g clip-rule="evenodd" fill="#99ea24" fill-rule="evenodd"><path d="m6.08372 8.06081c1.57579-3.67684 5.19118-6.06081 9.19148-6.06081h25.4496c4.0003 0 7.6157 2.38397 9.1915 6.06081l4.0837 9.52869v11.1718c-2.4315-1.1303-5.142-1.7613-8-1.7613-10.4934 0-19 8.5066-19 19 0 2.858.631 5.5685 1.7613 8h-14.7613c-6.62742 0-12-5.3726-12-12v-24.4105zm9.19148-2.06081c-2.4002 0-4.5694 1.43038-5.5149 3.63648l-2.72722 6.36352h18.96692v-10zm14.7248 0v10h18.9669l-2.7272-6.36351c-.9455-2.20611-3.1147-3.63649-5.5149-3.63649zm-15 34c1.1046 0 2 .8954 2 2s-.8954 2-2 2h-5c-1.10457 0-2-.8954-2-2s.89543-2 2-2z" /><path d="m46 30c-8.8366 0-16 7.1634-16 16s7.1634 16 16 16 16-7.1634 16-16-7.1634-16-16-16zm2.5858 15.4142c.781.7811 2.0474.7811 2.8284 0 .7811-.781.7811-2.0474 0-2.8284l-4-4c-.781-.7811-2.0474-.7811-2.8284 0l-4 4c-.7811.781-.7811 2.0474 0 2.8284.781.7811 2.0474.7811 2.8284 0l.5858-.5858v7.1716c0 1.1046.8954 2 2 2s2-.8954 2-2v-7.1716z" /></g></svg>);
        case '6':
            return (<svg xmlns="http://www.w3.org/2000/svg" id="Layer_1" height="512" viewBox="0 0 512 512" width="512" data-name="Layer 1"><g clip-rule="evenodd" fill="#99ea24" fill-rule="evenodd"><path d="m258 404.93a141.07 141.07 0 0 1 236.79-103.61q1-72.31-1.2-144.62c-.8-33.12-19.5-66.37-50.83-82.8-16.1-8.51-32.78-16.7-49.65-24.46-66.66 21.56-144.73 50-223.47 85.21a44.44 44.44 0 0 0 -26.43 38.68c-1.23 38-1.61 77.22-1.11 116a5.32 5.32 0 0 1 -9.61 3.33q-12.5-16-24.42-31.64a4 4 0 0 0 -5.31-1.09q-9.27 5.52-18.21 10.89c-3.34 2-7.45-.67-7.47-4.78-.2-38.63.76-77.36 2.83-114.9.87-15.83 10.8-30.74 25.49-38 75.52-37.3 156.09-67.77 224.84-90.32-16-6.26-31.91-12-47.44-17.44a99.49 99.49 0 0 0 -64.62 0c-51.82 17.88-108.41 41.22-159.97 68.52-31.32 16.43-50 49.68-50.83 82.8q-3.06 99.3 0 198.6c.8 33.12 19.51 66.37 50.83 82.8 51.56 27.3 108.15 50.64 160 68.51a99.49 99.49 0 0 0 64.62 0q6.79-2.34 13.71-4.83a140.07 140.07 0 0 1 -38.54-96.85z" /><path d="m399.07 297.87a107.07 107.07 0 1 0 107.08 107.06 107.07 107.07 0 0 0 -107.08-107.06zm61.07 89.34-64.36 67.58a18.84 18.84 0 0 1 -13.58 5.86h-.09a18.91 18.91 0 0 1 -13.55-5.73l-34.15-35.18a18.88 18.88 0 0 1 27.1-26.3l20.49 21.09 50.81-53.36a18.88 18.88 0 0 1 27.35 26z" /></g></svg>);
        default:
            return ''; // In case the status doesn't match any case
    }
};



export default ViewReferral;